import { useEffect, useState } from 'react';

import {
  Box,
  Card,
  CardHeader,
  Grid,
  TextField,
  useTheme
} from '@mui/material';
import { ValorPaySetting } from 'src/services/apiService/response-models';

function Sidebar(props: {
  onChange: (e: ValorPaySetting) => void;
  value?: ValorPaySetting;
}) {
  const [value, setValue] = useState<ValorPaySetting>(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return (
    <Box>
      <Card sx={{ m: 3, px: 2, pb: 3 }}>
        <CardHeader sx={{ pl: 0 }} title={'Valor Pay Settings'}></CardHeader>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="channelId"
              label="Channel Id"
              placeholder={'Enter Channel Id...'}
              variant="outlined"
              value={value?.channelId || ''}
              onChange={(e) => {
                const updateValue = {
                  ...value,
                  channelId: e.target.value
                };
                setValue(updateValue);
                props.onChange(updateValue);
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              name="EPI"
              label="EPI"
              placeholder={'Enter EPI...'}
              variant="outlined"
              value={value?.EPI || ''}
              onChange={(e) => {
                const updateValue = {
                  ...value,
                  EPI: e.target.value
                };
                setValue(updateValue);
                props.onChange(updateValue);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="appId"
              label="App Id"
              placeholder={'Enter App Id...'}
              variant="outlined"
              value={value?.appId || ''}
              onChange={(e) => {
                const updateValue = {
                  ...value,
                  appId: e.target.value
                };
                setValue(updateValue);
                props.onChange(updateValue);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              name="appKey"
              label="App Key"
              placeholder={'Enter App Key...'}
              variant="outlined"
              value={value?.appKey || ''}
              onChange={(e) => {
                const updateValue = {
                  ...value,
                  appKey: e.target.value
                };
                setValue(updateValue);
                props.onChange(updateValue);
              }}
            />
          </Grid>
        </Grid>
      </Card>
    </Box>
  );
}

export default Sidebar;
